import { Link } from "react-router-dom";
import React, { useState } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import UnipayLogo from "../assets/logo.png";
export default function Navbar() {
  const [nav, setNav] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  const NavElement = ({ to, label }) => {
    return (
      <li className="text-lg font-semibold text-gray-400 hover:text-white transition-colors float-left mr-4">
        <Link
          className="select-none"
          to={to}
          onClick={() => {
            setNav(!nav);
          }}
        >
          {label}
        </Link>
      </li>
    );
  };
  return (
    <div className="p-4 flex justify-between items-center max-w-[1400px] bg-gradient-to-r from-black to-[#181818] mx-auto rounded-lg">
      <div className="flex ">
        <img src={UnipayLogo} width="120px"></img>
        <h1 class=" pl-3 text-lg  md:text-2xl font-bold text-purple-500 select-none hover:text-white cursor-default ease-in-out duration-500">
          <Link
            className="select-none text-sm sm:text-base lg:text-xl "
            to="/"
          >
            Monad Testnet
          </Link>
        </h1>
      </div>

      <ul className="lg:flex flex-row">
        <NavElement to="/" label="Home" />
        <NavElement to="/mint" label="Mint" />
      </ul>

      <ConnectButton className="float-right" />

    </div>
  );
}
